import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

interface CallToActionProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
  phoneNumber?: string;
  variant?: 'primary' | 'secondary' | 'accent';
  className?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
  title = "Vuoi confrontare le offerte?",
  subtitle = "Parla con un nostro consulente per una consulenza gratuita e senza impegno",
  phoneNumber = "+390240055045",
  variant = 'primary',
  className = '',
}) => {
  const bgColor = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    accent: 'bg-accent text-light-text',
  };

  return (
    <div className={`${bgColor[variant]} py-16 px-4 md:px-8 rounded-lg shadow-md ${className}`}>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="mb-8 md:mb-0 md:mr-8">
            <h2 className={`text-3xl font-bold mb-4 ${variant === 'accent' ? 'text-primary' : 'text-white'}`}>
              {title}
            </h2>
            <p className={`text-lg ${variant === 'accent' ? 'text-light-text' : 'text-white/80'}`}>
              {subtitle}
            </p>
            <p className={`text-sm mt-2 ${variant === 'accent' ? 'text-light-muted' : 'text-white/50'}`}>
              Consulenza gratuita · Nessun obbligo · La scelta è tua
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href={`tel:${phoneNumber}`} 
              className="btn bg-white text-primary hover:bg-white/90 flex items-center justify-center"
            >
              <FontAwesomeIcon icon={faPhone} className="mr-2" />
              Consulenza Gratuita
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
